import React from 'react';
import LegalOverviewTemplate from "./LegalOverviewTemplate";
import MerchantOverviewTemplate from "./MerchantOverviewTemplate";

function Overview() {
    const dateOptions = {
        month: 'short'
    };

    const today = new Date();
    const formattedDate = `Today, ${new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(today)}, ${today.getDate()} ${today.toLocaleDateString('en-US', dateOptions)}`;

    return (
        <>
            {
                sessionStorage.getItem("EntityType")==="LEGALENTITY" ?
                    <LegalOverviewTemplate formattedDate={formattedDate}/>
                    :
                    <MerchantOverviewTemplate formattedDate={formattedDate}/>
            }
        </>

    );
}

export default Overview;